// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__OErpe","content":"styles_content__N0aIM","sideBar__active":"styles_sideBar__active__X+zyd","main":"styles_main__-+YBJ"};